<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="5">
              <b-form-group>
                <label>{{$t('page.generic.code')}} <required-field /></label>
                <b-form-input aria-describedby="codeField" :state="errors.some((e) => e.field === 'code')?false:null"
                              type="text" id="code" v-model="company.code" aria-required="true"
                              :required=true disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="5">
              <b-form-group>
                <label>{{$t('page.generic.name')}} <required-field /></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null"
                              type="text" id="label" v-model="company.label" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                <label for="active">{{$tc('page.generic.state', 1)}}</label><br/>
                <c-switch id="active" class="mx-1" v-model="company.active" color="success" variant="pill" label/>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label>{{$t('page.generic.description')}}</label>
                <b-form-textarea aria-describedby="descriptionField" :state="errors.some((e) => e.field === 'description')?false:null"
                                 type="text" id="description" v-model="company.description"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <company-models :tableData.sync="companyModels" @deleteCompanyModel="deleteCompanyModel"></company-models>
        <b-card>
          <b-col sm="12">
            <button class="btn btn-success float-right padder" type="button" @click="updateCompany">
              {{$t('actions.save')}}
            </button>
            <router-link class="btn btn-primary float-right" role="button" :to="{name: 'companyRoute'}">
              {{$t('actions.abort')}}
            </router-link>
          </b-col>
        </b-card>
        <model-list @addModels="addModels"></model-list>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import CompanyService from '@/services/CompanyService'
  import {Switch as cSwitch} from '@coreui/vue'
  import i18n from '@/config/i18n'
  import ModelList from "../company/ModelList";
  import CompanyModels from "../company/CompanyModels";
  import RequiredField from "../../components/RequiredField";

  const companyService = CompanyService.build();

  export default {
    name: 'companyEdit',
    inheritAttrs: false,
    components: {
      RequiredField,
      ModelList,
      CompanyModels,
      PageTitle,
      cSwitch
    },
    props: {
      id: {
        required: true
      }
    },
    data() {
      return {
        company: {},
        companyModels: [],
        errors: [],
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      miniToastr.setIcon('success', 'i', {'class': 'far fa-check'});
      this.fetchData();
    },
    methods: {
      async fetchData() {
        this.company = await companyService.read(this.id);
        const models = await companyService.modelsByCode(this.company.code);
        this.companyModels = models.sort((a, b) => a.orderModel - b.orderModel);
      },
      async updateCompany() {
        const orderedCompanyModels = this.companyModels.map((model, index) => {
          return {
            ...model,
            orderModel: index + 1
          };
        });
        let params = {
          label: this.company.label,
          description: this.company.description,
          companyModels: orderedCompanyModels,
          active: this.company.active
        };
        try{
          await companyService.mandatoryModels(this.company.code, params);
          await this.fetchData();
          miniToastr.success(i18n.t('page.message.success.update'));
          this.$router.push({name: 'companyShowRoute', params: {id: this.id}})
        } catch (e) {
          miniToastr.error(i18n.t('page.message.error.update'))
        }
      },
      deleteCompanyModel(selectedCompanyModel){
        let companyModel = this.companyModels.filter(obj => {
          return obj.id === selectedCompanyModel.id
        });
        if(companyModel[0].added){
          this.companyModels.splice(this.companyModels.findIndex(item => item.model.code === selectedCompanyModel.model.code), 1);
          miniToastr.success(i18n.t('page.message.success.update'));
        }else{
          this.companyModels.splice(this.companyModels.findIndex(item => item.id === selectedCompanyModel.id), 1);
        }
      },
      addModels(selectedModels) {
        let vm = this;
        selectedModels.forEach(function(element) {
          if(vm.companyModels.findIndex(item => item.model.code === element.code) === -1) {
            let cm = {
              id: -1,
              model: {
                id: element.id,
                code: element.code,
                categories: element.categories,
                description: element.description,
                modelVersion: element.modelVersion,
                modelFormat: element.modelFormat
              },
              mandatory: false,
              added: true
            };
            vm.companyModels.push(cm)
          }
        });
      },
    }
  }
</script>
